import {BaseFilter} from "./base.filter";

export class TransportServiceFilter extends BaseFilter {
  active: any;
}
